export const zIndexes = {
    notificationPanel: 12050
};
